import { observer, use$ } from '@legendapp/state/react';
import { Divider, Group, Image, Stack, Text } from '@mantine/core';
import Decimal from 'decimal.js';
import { configurationState$, winDisplayState$ } from '../../state';
import styles from './WinDisplay.module.css';

export const WinDisplay = observer(() => {
  const { isVisible, data } = use$(winDisplayState$);
  const { coeficient, currency, decimalScale } = use$(configurationState$);

  if (!data) {
    return null;
  }

  const { betAmount, rowsCleared, winAmount } = data;

  const multiplier = new Decimal(winAmount)
    .div(new Decimal(betAmount))
    .div(new Decimal(coeficient))
    .toFixed(2, Decimal.ROUND_DOWN);

  const payout = new Decimal(winAmount)
    .div(new Decimal(coeficient))
    .toFixed(decimalScale, Decimal.ROUND_DOWN);

  return (
    <div
      className={`${styles['win-display']} ${isVisible ? styles.visible : ''}`}
    >
      {/* Backdrop */}
      <div className={styles.backdrop} data-test-id="win-display-backdrop" />

      <Image
        alt="Cashout Frame"
        fit="cover"
        h="100%"
        left={0}
        pos="absolute"
        src="/game/cashout_frame.webp"
        style={{
          zIndex: 300,
        }}
        top={0}
        w="100%"
      />

      <Stack
        align="center"
        bottom={0}
        gap={0}
        h="100%"
        justify="center"
        left={0}
        pos="absolute"
        px={64}
        right={0}
        style={{ zIndex: 301 }}
        top="16%"
        w="100%"
      >
        <Text
          c="green.4"
          data-test-id="win-multiplier"
          fw={700}
          inline
          size="sm"
          style={{ fontVariantNumeric: 'tabular-nums' }}
          ta="center"
        >
          {multiplier}x
        </Text>

        <Divider mb={4} mt={6} size={2} w="100%" />

        <Group align="center" gap={6} justify="center" wrap="wrap">
          <Text
            c="white"
            data-test-id="win-payout"
            fw={500}
            size="sm"
            style={{ fontVariantNumeric: 'tabular-nums' }}
            ta="center"
          >
            {payout} {currency}
          </Text>
          <Group gap={4}>
            <Image
              alt="Coin"
              fit="contain"
              h={20}
              src="/icons/coin.webp"
              style={{ flexShrink: 0 }}
              w={20}
            />
            <Text
              c="green.4"
              data-test-id="win-rows-cleared"
              fw={700}
              size="sm"
              style={{ fontVariantNumeric: 'tabular-nums' }}
            >
              {rowsCleared}
            </Text>
          </Group>
        </Group>
      </Stack>
    </div>
  );
});
